<app-nav-red-logo></app-nav-red-logo>

<!-- <app-loader-pages *ngIf="isLoading"></app-loader-pages> -->
<main class="container" >
  <section class="w-100  first_container">
    <div>
      <h2 class="title">{{blog?.title}}</h2>
    </div>
  </section>
  @if (backgroundImageUrl) {
    <section class="w-100  my-5">
      <img  src="{{backgroundImageUrl}}" class="img-fluid" alt="">
    </section>
  }
  <section class="w-100  my-5">
    <div>
      <p class="blogText">{{blog?.blogText1}}</p>
    </div>
  </section>

  @if (blog?.cloudinaryUrls[1]) {
    <section class="w-100  my-5">
      <img  src="{{blog?.cloudinaryUrls[1]}}" class="img-fluid" alt="">
    </section>
  }
  <section class="w-100  ">
    <div>
      <p class="blogText">{{blog?.blogText2}}</p>
    </div>
  </section>

  @if (blog?.cloudinaryUrls[2]) {
    <section class="w-100  my-5">
      <img  src="{{blog?.cloudinaryUrls[2]}}" class="img-fluid" alt="">
    </section>
  }

  <section class="w-100  ">
    <div>
      <p class="blogText">{{blog?.blogText3}}</p>
    </div>
  </section>

</main>



<app-footer class="w-100 d-none d-sm-block"></app-footer>
<app-footer-sm  class="w-100 d-sm-none"></app-footer-sm>